<template>
    <div>
        <div class="flex justify-end mb-3" v-if="contacts.length >= 0">
            <button @click="openEmailContactModal()" type="button"
                    class="mx-1 py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline" style="margin-right: 44% !important;">Email Address Book</button>
            <input ref="filter" type="search"
                   class="bg-grey-lighter text-grey-darkest focus:outline-none p-2 rounded-full ml-3 text-sm"
                   placeholder="Search by name or email..." style="width: 30% !important;" @input="debounceFilter" v-model="search">
        </div>
        <div class="table-responsive">
            <table v-if="!loading && filteredList.length > 0" class="table text-left w-full border-collapse">
                <thead style="font-size: 13px;font-weight: 800;">
                <th class="py-3 px-4 bg-teal-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">Name</th>
                <th class="py-3 px-4 bg-teal-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">Company Name</th>
                <th class="py-3 px-4 bg-teal-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">Email</th>
                <th class="py-3 px-4 bg-teal-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">Phone Number</th>
                <th class="py-3 px-4 bg-teal-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light"></th>
                </thead>
                <tbody class="bg-grey-lightest">
                <tr v-for="(contact, index) in filteredList" :key="index + '-' + contact.email">
                    <td class="pl-3 py-2 text-grey-darkest text-xs hidden md:table-cell" style="word-break: break-all">{{contact.name}}</td>
                    <td class="pl-3 py-2 text-grey-darkest text-xs hidden md:table-cell">{{contact.company.name}}</td>
                    <td class="pl-3 py-2 text-grey-darkest text-xs" style="word-break: break-all">{{contact.email}}</td>
                    <td class="pl-3 py-2 text-grey-darkest text-xs hidden md:table-cell">
                        <formatted-phone
                            v-if="contact.cell"
                            :phone="contact.cell"
                            :masks="masks"/></td>
                    <td class="pl-3 py-2 text-grey-darkest text-xs">
                        <button @click="selectContact(contact)" class="btn btn-primary rounded-full" type="button">
                            <i class="fa fa-plus">
                            </i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!--        {{pagination}}-->
        <div v-if="pagination.data.total > pagination.data.per_page && !loading" class="flex justify-center mt-3">
            <b-pagination
                @change="goToPage"
                v-model="pagination.data.current_page"
                :total-rows="pagination.data.total"
                :per-page="pagination.data.per_page"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
            >
            </b-pagination>
        </div>
        <div class="flex justify-center my-3" v-if="!loading && filteredList.length === 0 && contacts.length === 0">
            <div class="alert alert-danger" role="alert">
                No contact was found!
            </div>
        </div>
        <!--        <div class="flex justify-center my-3" v-if="!loading && filteredList.length === 0 && contacts.length === 0">-->
        <!--            <div class="alert alert-danger" role="alert">-->
        <!--                No contacts found! <span class="hidden lg:inline">Have you registered an external email at your <a href="/settings">settings</a>?</span>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="flex justify-center my-3" v-if="loading">
            <i class="fa  fa-2x fa-spinner fa-spin text-teal"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'company-contact-create',
    props:['masks', 'symbols','exchange'],
    data() {
        return {
            contacts: [],
            filteredList: [],
            search: null,
            loading: false,
            filter: '',
            page: 1,
            pagination:{
                data: [],
                meta: {},
                links: {},
            }
        }
    },

    mounted() {
        this.loading = true;

        if (this.contacts.length > 0) {
            this.loading = false;
            return;
        }
        axios.get(route('api.contact.getAllCompaniesContacts'),{page: this.page})
            .then( (data) => {
                this.contacts     = data.data.data;
                this.filteredList = data.data.data;
                this.pagination = data;
                this.loading      = false;
            }).catch(error => {
            this.loading  = false;
        });
    },
    created() {
        this.fetchData();
    },

    methods: {
        goToPage(page) {
            this.page = page;
            this.fetchData();
        },
        fetchData(){
            this.loading = true;

            // if (this.contacts.length == 0) {
            //     this.loading = false;
            //     return;
            // }
            axios.get(route('api.contact.getAllCompaniesContacts', {page: this.page, filter: this.filter}))
                .then( (data) => {
                    this.contacts     = data.data.data;
                    this.filteredList = data.data.data;
                    this.pagination = data;
                    this.loading      = false;
                }).catch(error => {
                this.loading  = false;
            });
        },
        selectContact(contact)
        {
            this.$emit('selected', contact);
        },

        debounceFilter: _.debounce(function(e) {
            this.filter = e.target.value
            // this.filteredList = _.filter(this.contacts, contact => {
            //     return contact.name.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1 ||
            //         contact.email.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1;
            // });

            this.goToPage(1);
        }, 300),

        clear() {
            this.search       = null;
            this.filteredList = [ ...this.contacts ];
        },
        openEmailContactModal(){
            Bus.$emit('openEmailContactExternal','true');
        }
    }
}
</script>
